<template>
  <validation-observer ref="simpleRules">
    <user-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus"
    />
  </validation-observer>
</template>
<script>
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import UserForm from '@/views/Admin/Users/UserForm.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import toastMixin from '@/libs/toast'

export default {
  name: 'Edit',
  components: {
    UserForm,
    SaveButton,
    ValidationObserver,
  },
  mixins: [toastMixin],
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['users/dataItem']
    },
    saveData() {
      return this.$store.getters['users/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({ template: 'saveSuccess' })
      } else if (val.status === false) {
        this.showToast({ template: 'saveError' })
      }
    },
  },
  created() {
    this.getData()
    localize('tr')
  },
  methods: {
    getData() {
      this.$store.dispatch('users/getDataItem', this.$route.params.id)
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('users/saveData', this.dataItem)
        } else {
          this.showToast({ template: 'requireWarning' })
        }
      })
    },
  },
}
</script>
